<template>
  <div class="container">
    <form @submit.prevent="submitForm">
      <div class="row">
        <div class="col">
          <p><b>WELCOME!</b> Congratulations on your decision to implement the best way to input invoice information into your management system!</p>
          <p><i>Let's get started!</i></p>
          <hr />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="input-group mb-3">
            <span class="input-group-text" id="basic-firstname">First:<span class="custom-astrisk">*</span></span>
            <input
              v-model="form.firstname"
              type="text"
              class="form-control"
              placeholder="First Name"
              aria-label="FirstName"
              aria-describedby="basic-firstname"
              @keyup="changed"
            />
            <span v-if="!v$.firstname.required" class="text-danger">First Name is required</span>
          </div>
        </div>
        <div class="col">
          <div class="input-group mb-3">
            <span class="input-group-text" id="basic-lastname">Last:<span class="custom-astrisk">*</span></span>
            <input
              v-model="form.lastname"
              type="text"
              class="form-control"
              placeholder="Last Name"
              aria-label="LastName"
              aria-describedby="basic-lastname"
              @keyup="changed"
            />
            <span v-if="!v$.lastname.required" class="text-danger">Last Name is required</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="input-group mb-3">
            <span class="input-group-text" id="basic-email">Email:<span class="custom-astrisk">*</span></span>
            <input
              v-model="form.email"
              type="email"
              class="form-control"
              placeholder="Email"
              aria-label="Email"
              aria-describedby="basic-email"
              @keyup="changed"
            />
            <span v-if="!v$.email.required" class="text-danger">Email is required</span>
            <span v-if="!v$.email.email" class="text-danger">Email must be valid</span>
          </div>
        </div>
        <div class="col">
          <div class="input-group mb-3">
            <span class="input-group-text" id="basic-phone">Phone:<span class="custom-astrisk">*</span></span>
            <input
              v-model="form.phone"
              v-maska="'(###) ###-####'"
              class="form-control"
              placeholder="Phone"
              aria-label="Phone"
              aria-describedby="basic-phone"
              @keyup="changed"
            />
            <span v-if="!v$.phone.required" class="text-danger">Phone is required</span>
            <span v-if="!v$.phone.validPhone" class="text-danger">Phone must be valid</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <span class="custom-required-label">* required</span>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import useVuelidate from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'
import { vMaska } from 'maska/vue'
const validPhone = (value) => {
  const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/
  return phoneRegex.test(value)
}
export default {
  name: 'OnboardBasic',
  props: {
    companyId: {
      type: String,
      default: null
    }
  },
  directives: { maska: vMaska },
  data() {
    return {
      form: {
        type: 'basic',
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        marketing: null
      },
      isSave: false,
      rules: {
        firstname: { required },
        lastname: { required },
        email: { required, email },
        phone: { required, validPhone }
      },
      v$: null
    }
  },
  beforeMount() {
    this.isSave = false
    this.v$ = useVuelidate(this.rules, this.form)
  },
  emits: ['save'],
  methods: {
    updateData(data) {
      if (data !== undefined && data !== null) {
        this.form.marketing = data.id
      }
      this.isSave = false
      console.log('Updating Basic', this.form)
    },
    showEula() {
      this.$refs['modal-EULA'].show()
    },
    changed() {
      this.isSave = true
    },
    submitForm() {
      // this.save()
    },
    save() {
      this.v$.$touch()
      if (this.v$.$invalid) {
        this.form.valid = false
      } else {
        this.form.valid = true
        if (this.form.phone.length > 20) {
          this.form.phone = this.form.phone.substring(0, 19)
        }
      }
      this.$emit('save', this.form)
      return this.form.valid
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-phone-wrapper {
  margin-left: 0;
  margin-right: 0;
}
.custom-phone-cc {
  width: 100px;
}
.custom-phone {
  margin-top: 31px;
  margin-left: 10px;
}
.custom-astrisk {
  position: relative;
  color: red;
  font-size: 0.8em;
  top: -5px;
  left: 5px;
}
.custom-required-label {
  font-size: 0.8em;
  color: red;
}
</style>
